import { Configuration, FeatureFlagsApi } from '@invitae/stargate-ts-fetch';

var _a;
var configuration = new Configuration({
    // stargate lib doesn't like trailing slashes on test env
    basePath: (_a = process.env.API_GATEWAY) === null || _a === void 0 ? void 0 : _a.replace(/\/$/, ''),
});
var featureFlags = new FeatureFlagsApi(configuration);
var stargate = Object.freeze({ featureFlags: featureFlags });

export { stargate };
//# sourceMappingURL=stargateService.esm.js.map
